import React, { useMemo } from 'react';
import classnames from 'classnames';
import { useLatest } from 'ahooks';
import GPBaseSelectMultiple from './BaseSelectMultiple';
import useSelectMultiple from './_hooks/useSelectMultiple';
import { formatOptions } from '@gp/components/Select/utils';
import { defaultOptionTextRenderer } from '@gp/components/Select/utils/renderers';
import { ALL_OPTION } from '@gp/constants/select';

const GPSelectMultiple: React.FC<IGPSelectMultipleProps> = (props) => {
  const {
    overlayClassName,
    required = true,
    sortable = true,
    isNeedEmptyAll = true, // 是否需要关闭且值为空的，全选
    staging = false,
    showPlaceholder = false,
    /** 解构出搜索相关的参数，避免搜索相关的参数传递到下层基础组件，因为本组件不支持搜索交互 **/
    searchable,
    searchPlaceholder,
    filter,
    searchValue,
    onSearchValueChange,
    onSearch,
    /** 解构出搜索相关的参数，避免搜索相关的参数传递到下层基础组件，因为本组件不支持搜索交互 **/
    allOption = ALL_OPTION,
    optionTextRenderer = defaultOptionTextRenderer,
    options: optionsProps,
    value: valueProps = [],
    onChange,
    onChangePa,
    onChangeValue,
    renderOption,
    onOpen,
    onClose,
    label,
    ...restProps
  } = props;

  const optionTextRendererLatest = useLatest<IGPSelectOptionTextRenderer>(optionTextRenderer);

  const options = useMemo<IGPSelectOptionWithGroup[]>(() => {
    return formatOptions(optionsProps, { optionTextRenderer: optionTextRendererLatest.current });
  }, [optionsProps]);

  const {
    dividedOptions,
    value,
    onChange: handleChange,
    onOpen: handleOpen,
    onClose: handleClose,
  } = useSelectMultiple({
    required,
    sortable,
    staging,
    isNeedEmptyAll,
    options,
    value: valueProps,
    onChange,
    onChangePa,
    onOpen,
    onClose,
    onChangeValue,
  });

  return (
    <GPBaseSelectMultiple
      {...restProps}
      overlayClassName={classnames(overlayClassName, {
        'dbg-common-select-multiple-overlay--all-option': !!allOption,
      })}
      staging={staging}
      allOption={allOption}
      options={dividedOptions}
      renderOption={renderOption}
      isNeedEmptyAll={isNeedEmptyAll}
      value={value}
      onChange={handleChange}
      onOpen={handleOpen}
      label={label}
      showPlaceholder={showPlaceholder}
      onClose={handleClose}
    />
  );
};

export default GPSelectMultiple;
